module.exports = __webpack_public_path__ + "img/netcash-full-blue.2e39054.svg";